<template>
    <div class="TrainingClassUpdate">
        <v-card>
            <v-toolbar flat light color="grey lighten-4">

                <v-spacer/>
                <v-btn color="light-green" @click="save" dark>Save</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="2">
                        <h3>Class Details</h3>
                    </v-col>
                    <v-col cols="10">

                        <v-form>
                            <v-form-base :col="12" :model="model" :schema="schema"/>
                            <HtmlEditor v-model="model.virtualDetails" label="Virtual Details"/>
                            <br/>
                            <HtmlEditor v-model="model.coursewareDetails" label="Courseware Details"/>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

    import VFormBase from 'vuetify-form-base';
    import REPRESENTATIVES from "../../graphql/RepresentativesAll.gql";
    import TRAINING_CLASS_UPDATE from "../../graphql/TrainingClassUpdate.gql"
    import HtmlEditor from "../HtmlEditor";

    export default {
        components: {
            VFormBase,
            HtmlEditor
        },
        props: {
            model: Object,
        },
        data() {
            return {
                updating: true
            }
        },
        apollo: {
            representatives: {
                query: REPRESENTATIVES,
                update: data => data.representatives
            },
        },
        watch: {
            updating(value) {
                this.$store.dispatch('notification/loading', value)
            }
        },
        computed: {
            schema() {
                return {
                    title: {type: 'text', label: 'Title'},
                    company: {type: 'text', label: 'Company'},
                    representative: {
                        type: 'select',
                        returnObject: true,
                        items: this.representatives,
                        itemText: "firstName",
                        "item-value": "id",
                        label: 'Representative',
                        model: 'id',

                    },
                    sendFeedbackEmail: {type: 'checkbox', label: 'Send Feedback Email'}
                }
            }
        },

        methods: {
            save() {
                this.updating = true
                this.$apollo.mutate({
                    mutation: TRAINING_CLASS_UPDATE,
                    variables: {
                        trainingClass: {
                            id: this.model.id,
                            title: this.model.title,
                            company: this.model.company,
                            representative: {connect: this.model.representative.id},
                            sendFeedbackEmail: this.model.sendFeedbackEmail,
                            virtualDetails: this.model.virtualDetails,
                            coursewareDetails: this.model.coursewareDetails
                        }
                    }
                }).then(() => {
                    this.updating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Save successful')
                }).catch((error) => {
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

        }
    };
</script>
